import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const WelcomeBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-primary/20 via-primary/10 to-transparent rounded-lg shadow-elevation-2 border border-primary/30 p-6 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
      
      <div className="relative z-10">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center">
                <Icon name="Sparkles" size={24} color="var(--color-primary)" strokeWidth={2.5} />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-foreground">Welcome to Bee Wise, Marko!</h1>
                <p className="text-sm text-muted-foreground">Junior Developer • Day 1</p>
              </div>
            </div>
            
            <p className="text-base text-foreground mb-4 max-w-2xl">
              Your onboarding journey starts here. Complete tasks, earn XP, and level up from Rookie to Colleague. We're here to make your first days smooth and productive.
            </p>
            
            <div className="flex flex-wrap gap-3">
              <Button
                variant="default"
                iconName="Rocket"
                iconPosition="left"
                onClick={() => navigate('/start-here-hub')}
              >
                Start Your Journey
              </Button>
              <Button
                variant="outline"
                iconName="MessageCircle"
                iconPosition="left"
              >
                Chat with Bee
              </Button>
            </div>
          </div>
          
          <div className="hidden lg:block">
            <div className="w-32 h-32 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="Hexagon" size={64} color="var(--color-primary)" strokeWidth={1.5} />
            </div>
          </div>
        </div>
        
        <div className="mt-6 pt-6 border-t border-border/50">
          <div className="flex flex-wrap items-center gap-6">
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground">Started: 22/11/2025</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Target" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground">Goal: Complete onboarding in 7 days</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Award" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground">Current Level: Rookie</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;